document.addEventListener("DOMContentLoaded", () => {
    const elements = document.querySelectorAll("[data-simplebar]");

    if (elements.length === 0) {
        return;
    }

    import("simplebar/dist/simplebar.min.css");
    import("../../css/simplebar-overrides.css");
    import("simplebar").then(({ default: SimpleBar }) => {
        elements.forEach((el) => new SimpleBar(el));
    });
});
